import React from 'react';
import gql from 'graphql-tag';
import { Card } from '@zillow/constellation';
import {
    ONSITE_MESSAGING_FRAGMENT,
    NFSOnsiteMessagingWrapper,
} from '@zillow/home-details-nfs-onsite-messaging';

import type { Property } from '../types/@zillow-types/pongo';

interface OmpHomeWorthUpsellProps {
    property: Property;
    abTests: { HMIMHW_ZO_NFS_UPSELL_ONSITE_MESSAGING: string };
    additionalProps: { signalForTriggerTracking: boolean };
}

const OmpHomeWorthUpsell = ({ property, abTests, additionalProps }: OmpHomeWorthUpsellProps) => {
    const { onsiteMessage } = property;
    const triggerLocation = 'how_much_is_my_home_worth';
    const triggerObject = 'no_trigger_object';
    const triggerSource = 'top';

    return (
        <Card
            data-testid="hmimhw-omp-upsell-card"
            cardType="secondary"
            padding="sm"
            cardElevation={0}
        >
            <NFSOnsiteMessagingWrapper
                abBucket={abTests.HMIMHW_ZO_NFS_UPSELL_ONSITE_MESSAGING}
                messageData={onsiteMessage}
                additionalProps={additionalProps}
                placementName="HMIMHWTopSlot"
                triggerLocation={triggerLocation}
                triggerObject={triggerObject}
                triggerSource={triggerSource}
            />
        </Card>
    );
};

OmpHomeWorthUpsell.fragments = {
    // OmpHomeWorthUpsell fields can be found in HowMuchIsMyHomeWorthReviewQuery
    property: gql`
        fragment OmpHomeWorthUpsell_property on Property {
            zpid
            onsiteMessage(placementNames: ["HMIMHWTopSlot"]) {
                ...onsiteMessage_fragment
            }
        }
        ${ONSITE_MESSAGING_FRAGMENT}
    `,
    abTests: gql`
        fragment OmpHomeWorthUpsell_abTests on ABTests {
            HMIMHW_ZO_NFS_UPSELL_ONSITE_MESSAGING: abTest(
                trial: "HMIMHW_ZO_NFS_UPSELL_ONSITE_MESSAGING"
            )
        }
    `,
};

export default OmpHomeWorthUpsell;
